import { CompanyData } from "../../graphql";

export type TranslationKey =
    | "analyze_selection.user_name"
    | "analyze_selection.select_info"
    | "analyze_selection.analyze_saas"
    | "analyze_selection.analyze_saas_tag"
    | "analyze_selection.why_choose_saas"
    | "analyze_selection.learn_more_saas.step_1.heading"
    | "analyze_selection.learn_more_saas.step_1.description"
    | "analyze_selection.learn_more_saas.step_2.heading"
    | "analyze_selection.learn_more_saas.step_2.description"
    | "analyze_selection.learn_more_saas.step_3.heading"
    | "analyze_selection.learn_more_saas.step_3.description"
    | "analyze_selection.learn_more_saas.step_4.heading"
    | "analyze_selection.learn_more_saas.step_4.description"
    | "analyze_selection.considerations"
    | "analyze_selection.point_to_note_saas.step_1.heading"
    | "analyze_selection.point_to_note_saas.step_1.description"
    | "analyze_selection.point_to_note_saas.step_2.heading"
    | "analyze_selection.point_to_note_saas.step_2.description"
    | "analyze_selection.best_for"
    | "analyze_selection.best_for_saas.step_1"
    | "analyze_selection.best_for_saas.step_2"
    | "analyze_selection.best_for_saas.step_3"
    | "analyze_selection.analyze_on_prem"
    | "analyze_selection.analyze_on_prem_tag"
    | "analyze_selection.why_choose_on_prem"
    | "analyze_selection.learn_more_on_prem.step_1.heading"
    | "analyze_selection.learn_more_on_prem.step_1.description"
    | "analyze_selection.learn_more_on_prem.step_2.heading"
    | "analyze_selection.learn_more_on_prem.step_2.description"
    | "analyze_selection.learn_more_on_prem.step_3.heading"
    | "analyze_selection.learn_more_on_prem.step_3.description"
    | "analyze_selection.point_to_note_on_prem.step_1.heading"
    | "analyze_selection.point_to_note_on_prem.step_1.description"
    | "analyze_selection.point_to_note_on_prem.step_2.heading"
    | "analyze_selection.point_to_note_on_prem.step_2.description"
    | "analyze_selection.best_for_on_prem.step_1"
    | "analyze_selection.best_for_on_prem.step_2"
    | "analyze_selection.best_for_on_prem.step_3"
    | "analyze_selection.on_prem_button";

export interface AnalyzeSelectionProps {
    user_name?: string;
}

export enum AnalyzeType {
    AnalyzeOnPrem = "AnalyzeOnPrem",
    AnalyzeSaaS = "AnalyzeSaaS",
}

export const SAASTAG = "SaaS";

export interface ConfigureAnalyzeSassPrintersList {
    serialNumber?: string;
    printerModel?: string;
    license?: string;
    licenseStart?: string;
    licenseExpiry?: string;
    channel?: string;
    location?: string;
    tag?: string;
}

export interface LicenseDetailsPerPrinter {
    licenseName: string;
    startDate: string;
    endDate: string;
}

export interface CircularSegmentElementProps {
    total: number;
    element: string;
}

export interface ConfigureAnalyzeSaaSProps {
    listOfPrinters: ConfigureAnalyzeSassPrintersList[];
    gatewayPrinterCount: number;
    printServerPrinterCount: number;
    company?: CompanyData;
    streamlineProLicenceCount: number;
}
